import React from "react";
import "./TransportManagement.css";
import { 
  CheckCircleFilled, 
  ArrowRightOutlined,
  DatabaseOutlined,
  SafetyCertificateOutlined,
  RocketOutlined,
  CarOutlined,
  CheckOutlined,
  CloudOutlined,
  ThunderboltFilled,
} from "@ant-design/icons";
import transportImage from "../../Asset/transport-management.png";

const featuresLeft = [
  "Manage Multiple Company",
  "Manage Consignee and Consigner",
  "Manage Orders",
  "Manage Truck Dispatch",
  "Generate Bilty",
  "Order and Bilty Receiving",
  "Order and Bilty Payment",
  "Other Truck Owner Payment",
  "Truck Profit & Loss Report",
  "Daily Cashbook",
];

const featuresRight = [
  "Accounts Management",
  "Truck Service & License Alerts",
  "SMS Alerts & Notifications",
  "Automated Reminders",
  "Truck Service & Maintenance",
  "Payroll Management",
  "Driver Book",
  "Diesel and Tyre Records",
  "Inventory Management",
  "Variety of Reports",
];

const highlights = [
  {
    icon: <DatabaseOutlined />,
    title: "Cloud Database",
    desc: "Secure distributed data system",
  },
  {
    icon: <SafetyCertificateOutlined />,
    title: "Secure Access",
    desc: "Enterprise-grade privacy",
  },
  {
    icon: <RocketOutlined />,
    title: "Fast Operations",
    desc: "Streamlined workflows",
  },
];

const TransportManagement = () => {
  const handleViewMore = () => {
    window.open("/transport-details", "_blank");
  };

  return (
    <div className="tms-page-light">
      {/* Decorative Background */}
      <div className="tms-bg-grid"></div>
      <div className="tms-glow-1"></div>
      <div className="tms-glow-2"></div>

      <div className="tms-container">
        
        {/* ═══════ NEW SIMPLE & PROFESSIONAL HEADER ═══════ */}
        <div className="tms-header-new">
          <div className="tms-header-top">
            <span className="tms-badge">
              <span className="tms-badge-dot"></span>
              LOGISTICS PRODUCT
            </span>
            <span className="tms-version-tag">
              <ThunderboltFilled /> Version 3.0
            </span>
          </div>

          <div className="tms-header-main">
            <div className="tms-header-icon-box">
              <CarOutlined />
            </div>
            <div className="tms-header-text">
              <h1 className="tms-title-new">
                Transport Management <span className="tms-gradient-text">System</span>
              </h1>
              <p className="tms-subtitle-new">
                An enterprise-grade digital platform designed to streamline daily transport 
                operations, automate goods handling, and empower logistics companies with real-time insights.
              </p>
            </div>
          </div>

          {/* Meta Info Pills */}
          <div className="tms-meta-pills">
            <span className="tms-meta-pill">
              <CheckOutlined /> Live Demo Available
            </span>
            <span className="tms-meta-pill">
              <SafetyCertificateOutlined /> Enterprise Ready
            </span>
            <span className="tms-meta-pill">
              <CloudOutlined /> Cloud-Based Software
            </span>
            <span className="tms-meta-pill">
              <RocketOutlined /> 24/7 Support Included
            </span>
          </div>
        </div>

        {/* MAIN CONTENT GRID */}
        <div className="tms-main-content">
          
          {/* LEFT — IMAGE & HIGHLIGHTS */}
          <div className="tms-left-col">
            <div className="tms-image-wrapper">
              <div className="tms-image-glow"></div>
              <img
                src={transportImage}
                alt="Transport Management System"
                className="tms-image"
              />
              <div className="tms-image-badge">
                <CarOutlined /> TMS Dashboard
              </div>
            </div>

            {/* Highlights Row */}
            <div className="tms-highlights">
              {highlights.map((item, index) => (
                <div className="tms-highlight-card" key={index}>
                  <div className="tms-highlight-icon">{item.icon}</div>
                  <div className="tms-highlight-text">
                    <h5>{item.title}</h5>
                    <p>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT — INFORMATION */}
          <div className="tms-right-col">
            <div className="tms-info-block">
              <p className="tms-para">
                A design called <strong>TMS (Transport Management System)</strong> was 
                created to help <strong>Goods Transport Companies</strong> properly handle 
                their everyday transactions. In other words, this software completely 
                automates the transport management process from end-to-end.
              </p>

              <p className="tms-para">
                TMS is essentially a <strong>distributed database system</strong> that 
                may be accessed using a private web browser. It empowers dispatchers, 
                transporters, and service workers to manage daily transportation 
                activities with maximum efficiency and precision.
              </p>
            </div>

            {/* FEATURES SECTION */}
            <div className="tms-features-section">
              <h2 className="tms-features-title">
                <span className="title-accent">Key Features</span> & Benefits
              </h2>
              <p className="tms-features-desc">
                Explore the comprehensive suite of features designed to elevate 
                your transportation business.
              </p>

              <div className="tms-features-grid">
                <ul className="tms-features-list">
                  {featuresLeft.map((feature, index) => (
                    <li key={index}>
                      <CheckCircleFilled className="tms-check-icon" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                <ul className="tms-features-list">
                  {featuresRight.map((feature, index) => (
                    <li key={index}>
                      <CheckCircleFilled className="tms-check-icon" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* CTA BUTTON */}
            {/* <div className="tms-cta-wrap">
              <button className="tms-view-btn" onClick={handleViewMore}>
                <span>Explore Full Details</span>
                <ArrowRightOutlined />
              </button>
              <p className="tms-cta-note">
                💡 Get a live demo and pricing consultation
              </p>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransportManagement;